import { useEffect, useMemo, useState } from "react";

import debounce from "lodash.debounce";
import { Search } from "lucide-react";

import { ClearInputButton } from "@components/clear-input-button";
import { Input } from "@components/input/input";

import { useStoreZustandMinhasTarefas } from "@/store-zustand/admin/minhas-tarefas";

export function SearchInputMinhasTarefas() {
  const { searchItem, setSearchItem, setCurrentPage } = useStoreZustandMinhasTarefas();
  const [value, setValue] = useState(searchItem ?? "");

  const debouncedSearch = useMemo(
    () =>
      debounce((term: string) => {
        setCurrentPage(1);
        setSearchItem(term);
      }, 400),
    [setSearchItem, setCurrentPage]
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const term = e.target.value;
    setValue(term);
    if (term.length >= 2 || term.length === 0) {
      debouncedSearch(term.trim());
    }
  };

  const handleClear = () => {
    setValue("");
    debouncedSearch("");
    debouncedSearch.flush();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      debouncedSearch.flush();
    }
  };

  useEffect(() => {
    return () => debouncedSearch.cancel();
  }, [debouncedSearch]);

  return (
    <form className="relative ml-auto flex-1 md:grow-0" onSubmit={(e) => e.preventDefault()}>
      <Search className="absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        id="search-input"
        aria-label="Pesquisar remessas"
        name="q"
        type="search"
        autoComplete="off"
        enterKeyHint="search"
        placeholder="Nº remessa, Cliente, Status e Modelo"
        className="w-full rounded-lg bg-background pl-8 pr-12 focus:outline-none md:w-[200px] lg:w-[336px]"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      {value && <ClearInputButton onClick={handleClear} />}
    </form>
  );
}
